import { getCookie, setCookie } from "cookies-next";
import secretApiAxios from "../../endpoints/core/secretApiAxios";
import { _FilterResponseDataLead } from "./_FilterResponseDataLead";
import { COOKIES_TAGS } from "../../../functions/cookies/COOKIES_TAGS";
import { SetLog, TagLogs } from "../../logs/set-log";
import { _FindLead } from "./_FindLead";
import { ConcessionariaService } from "../concessionaria";
import { removeUndefinedFieldsFromObj } from "../../../functions/filterObject";

export const _SaveLead = async (data, context) => {
  let parsedData = {
    id: data.id ? data.id : getCookie(COOKIES_TAGS.LEAD_ID, context),
    nome: data.nome,
    sobrenome: data.sobrenome,
    valor_consumo: data.valor_consumo,
    email: data.email,
    celular: data.celular,
    tipo: data.tipo,
    municipio: data.municipio,
    uf: data.uf,
    nome_concessionaria: parseInt(data.concessionaria)
      ? (await ConcessionariaService.findById(data.concessionaria)).attributes
          .sigagente
      : undefined,
    usina: data.usina,
    assessor: data.assessor,
    campanha: data.campanha,
    origem_api: data.origem_api,
    valor_consumo: data.valor_consumo,
    desconto_anual_previsto: data.desconto_anual_previsto,
    desconto_usina: data.desconto_usina,
    prazo_cancelamento_contrato_meses: data.prazo_cancelamento_contrato_meses,
    prazo_contrato_meses: data.prazo_contrato_meses,
    descricao_prazo_contrato: data.descricao_prazo_contrato,
    text_prazo_implantacao: data.text_prazo_implantacao,
    pipe_id: data.pipe_id,
    sms_code: data.sms_code,
    // expires_time: data.expires_time ? new Date(data.expires_time) : undefined,
    attempts: data.attempts,
    sms_confirmed: data.sms_confirmed,
    usina: data.usina,
    contrato_plano_usina: data.contrato_plano_usina,
    az_documento: data.az_documento,
    az_arquivo_conta: data.az_arquivo_conta,
    az_contrato_social: data.az_contrato_social,
    cep_contrato: data.cep_contrato,
    taxvat_contrato: data.taxvat_contrato,
    numero_endereco_contrato: data.numero_endereco_contrato,
    endereco_contrato: data.endereco_contrato,
    nome_contrato: data.nome_contrato,
    estado_civil: data.estado_civil,
    profissao: data.profissao,
    serasa_data: data.serasa_data,
    serasa_status: data.serasa_status,

    iniciado_envio_link_registro: data.iniciado_envio_link_registro,
    status_finalizacao_envio_link_registro: data.status_finalizacao_envio_link_registro,

    iniciado_envio_contrato: data.iniciado_envio_contrato,
    status_finalizacao_envio_contrato: data.status_finalizacao_envio_contrato,
    external_id: data.external_id,
    link_documentos: data.link_documentos,
  };

  parsedData = removeUndefinedFieldsFromObj(parsedData);

  const currentLead = await _FindLead({
    id: parsedData.id,
    context,
  });

  if (parsedData.id && currentLead && !isUpdatableLead(currentLead)) {
    return {
      status: false,
      error_msg: "not_updatable_lead",
      currentLead,
    };
  }

  const resultSavedLead =
    parsedData.id && currentLead
      ? await update(parsedData)
      : await create(parsedData);

  delete resultSavedLead?.data?.pipe_id;
  if (resultSavedLead?.data?.id) {
    setCookie(COOKIES_TAGS.LEAD_ID, resultSavedLead?.data?.id, context);
  }

  return resultSavedLead;
};

async function update(data) {
  const resultUpdate = await secretApiAxios
    .put(`leads/${parseInt(data.id)}?populate=usina,concessionaria`, {
      data,
    })
    .then((data) => data.data)
    .catch((err) => {
      SetLog(TagLogs.error_update_lead, data, false);
      return false;
    });

  return _FilterResponseDataLead(resultUpdate);
}

async function create(data) {
  const { id, ...parsedData } = data;
  const resultCreate = await secretApiAxios
    .post(`leads?populate=usina,concessionaria`, {
      data: parsedData,
    })
    .then((data) => data.data)
    .catch((err) => {
      console.log(err.message);
      SetLog(TagLogs.error_create_lead, data, false);
      return false;
    });
  return _FilterResponseDataLead(resultCreate);
}

function isUpdatableLead(lead) {
  if (!lead) {
    return false;
  }
  if (lead.attributes.conta) {
    return false;
  }

  return true;
}
